export default __webpack_public_path__ + "static/media/logo-img.8aa65afe.png";